module.exports = __webpack_public_path__ + "static/community-slideshow-02@2x-0bc1cf5c335b03d1f120008dac6634a1.jpg";